export default __webpack_public_path__ + "static/undraw_hang_out_edited-3b408e29aa4e28b90e051646fe8bfc96.svg";